import { FullPageWrapper } from "@repo/ui/index.tsx";

const BrocorePolicy = () => {
  const brocoreToken = localStorage.getItem("brocoreToken");
  const encodeToken = window.encodeURIComponent(String(brocoreToken));
  const iframeUrl = `https://demobrocore.fynity.in/search-proceed?id=affinity&token=${encodeToken}`;
  return (
    <FullPageWrapper>
      <iframe
        className="w-full h-[calc(100vh-90px)] "
        src={iframeUrl}
        title="Broker Policy"
        allowFullScreen
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      />
    </FullPageWrapper>
  );
};

export default BrocorePolicy;
